import axios from "axios";
import { ENDPOINTS } from "./endpoints";

export const getAllTransactions = async ({ ...data }) => {
  const params = { limit: 10, ...data };
  try {
    const response = await axios(ENDPOINTS.ALL_TRANSACTIONS, { params });
    const data = await response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getAllTransactionsAnalytics = async (params) => {
  try {
    const response = await axios(ENDPOINTS.TRANSACTION_ANALYTICS, { params: { ...params } });
    const data = await response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getTransactionMetrics = async (params) => {
  try {
    const response = await axios(ENDPOINTS.TRANSACTION_METRICS, { params: { ...params } });
    const data = await response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const updateSingleTransaction = async ({ id, status, reason, file, mfaCode }) => {
  const body =
    status === "Failed"
      ? {
        status,
        reason,
        mfaCode
      }
      : {
        mfaCode,
        status,
        url: {
          url: file?.url,
          name: file?.name,
        },
      };
  try {
    const response = await axios.post(ENDPOINTS.SINGLE_TRANSACTION(id), {
      ...body
    }, {
      headers: {
        mfaCode
      }
    });
    const data = await response.data;
    return data;
  } catch (error) {
    console.error(error);
    return error
  }
};

export const acceptRepayment = async (data) => {
  const { id, loanId, ...rest } = data;
  try {
    const response = await axios.post(ENDPOINTS.UPDATE_REPAYMENT(id, loanId), {
      ...rest
    });
    const data = await response.data;
    return data;
  } catch (error) {
    console.error(error);
    return error
  }
};
